import { useEffect, useState } from 'react'
import { API_BASE_URL } from '../config'
import {
  getServiceStatus,
  probeServiceStatus,
  subscribeServiceStatus,
  type ServiceStatus,
} from '../services/serviceStatus'

/**
 * Subscribes to whether the admin API is reachable.
 *
 * `ready` is false until the boot probe has answered, so the app can hold off
 * rendering rather than flashing the dashboard and then replacing it.
 */
export const useServiceStatus = (): ServiceStatus & { ready: boolean } => {
  const [state, setState] = useState<ServiceStatus>(getServiceStatus)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const unsubscribe = subscribeServiceStatus(setState)

    let cancelled = false
    void probeServiceStatus(API_BASE_URL).then(() => {
      if (!cancelled) setReady(true)
    })

    return () => {
      cancelled = true
      unsubscribe()
    }
  }, [])

  return { ...state, ready }
}
